<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="themeObjectValues"
                show-decimal
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

export default {
    name: 'line-height',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Line Height',
            tailwindDefinitionProp: 'lineHeight',
        };
    },
};
</script>
